export const URL = {
    SUPPORT_LINK: 'https://inside-docupedia.bosch.com/confluence/x/95xylw'
}